var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.activeData.config.tag === "el-select"
        ? _c(
            "el-form-item",
            { attrs: { label: "能否搜索" } },
            [
              _c("el-switch", {
                model: {
                  value: _vm.activeData.filterable,
                  callback: function ($$v) {
                    _vm.$set(_vm.activeData, "filterable", $$v)
                  },
                  expression: "activeData.filterable",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.activeData.config.tag === "el-select"
        ? _c(
            "el-form-item",
            { attrs: { label: "是否多选" } },
            [
              _c("el-switch", {
                on: { change: _vm.multipleChange },
                model: {
                  value: _vm.activeData.multiple,
                  callback: function ($$v) {
                    _vm.$set(_vm.activeData, "multiple", $$v)
                  },
                  expression: "activeData.multiple",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("config-item-option", { attrs: { "active-data": _vm.activeData } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }